"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var OnlineShopperEvent;

(function (OnlineShopperEvent) {
  OnlineShopperEvent[OnlineShopperEvent["AddUpgrade"] = 0] = "AddUpgrade";
  OnlineShopperEvent[OnlineShopperEvent["AppointmentScheduled"] = 1] = "AppointmentScheduled";
  OnlineShopperEvent[OnlineShopperEvent["BuildNewPayment"] = 2] = "BuildNewPayment";
  OnlineShopperEvent[OnlineShopperEvent["CalculationFinish"] = 3] = "CalculationFinish";
  OnlineShopperEvent[OnlineShopperEvent["CompletedCreditApp"] = 4] = "CompletedCreditApp";
  OnlineShopperEvent[OnlineShopperEvent["CompletesTrade"] = 5] = "CompletesTrade";
  OnlineShopperEvent[OnlineShopperEvent["ContinueDeal"] = 6] = "ContinueDeal";
  OnlineShopperEvent[OnlineShopperEvent["CosignerYes"] = 7] = "CosignerYes";
  OnlineShopperEvent[OnlineShopperEvent["CreditAppPrimaryPageTwo"] = 8] = "CreditAppPrimaryPageTwo";
  OnlineShopperEvent[OnlineShopperEvent["ExploreUpgrades"] = 9] = "ExploreUpgrades";
  OnlineShopperEvent[OnlineShopperEvent["HasTrade"] = 10] = "HasTrade";
  OnlineShopperEvent[OnlineShopperEvent["PickDeliveryDate"] = 11] = "PickDeliveryDate";
  OnlineShopperEvent[OnlineShopperEvent["PickDeliveryTime"] = 12] = "PickDeliveryTime";
  OnlineShopperEvent[OnlineShopperEvent["SavesPayment"] = 13] = "SavesPayment";
  OnlineShopperEvent[OnlineShopperEvent["SignInToGarageGarageIcon"] = 14] = "SignInToGarageGarageIcon";
  OnlineShopperEvent[OnlineShopperEvent["SkipCreditApp"] = 15] = "SkipCreditApp";
  OnlineShopperEvent[OnlineShopperEvent["SkipUpgrades"] = 16] = "SkipUpgrades";
  OnlineShopperEvent[OnlineShopperEvent["SoftPullCreditAppComplete"] = 17] = "SoftPullCreditAppComplete";
  OnlineShopperEvent[OnlineShopperEvent["StartedCreditApp"] = 18] = "StartedCreditApp";
})(OnlineShopperEvent = exports.OnlineShopperEvent || (exports.OnlineShopperEvent = {}));